import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { refreshKeyword } from "../../store/actions/keywordActions";
import { Sync } from "@material-ui/icons";
import LCIconButton from "../styles/LCIconButton";

const RefreshKeywords = ({ keyword }) => {
  const dispatcher = useDispatch();
  const domain = useSelector((state) => state.domains.currentDomain);
  const reCheckList = useSelector((state) => state.keywords.removals);
  const keywordsObj = useSelector((state) => state.keywords);

  const refreshKeywords = () => {
    if (keyword) {
      dispatcher(
        refreshKeyword(
          domain._id,
          [keyword._id],
          keywordsObj.pageNum,
          keywordsObj.search,
          keywordsObj.sort,
          keywordsObj.limit
        )
      );
    } else {
      dispatcher(
        refreshKeyword(
          domain._id,
          reCheckList,
          keywordsObj.pageNum,
          keywordsObj.search,
          keywordsObj.sort,
          keywordsObj.limit
        )
      );
    }
  };

  return (
    <span>
      <LCIconButton as="button" onClick={() => refreshKeywords()}>
        {keyword ? <Sync /> : "Re-Check Ranks"}
      </LCIconButton>
    </span>
  );
};

export default RefreshKeywords;
